const defaultFormat = 'MM/DD/YYYY HH:mm';

export const dateTimeFormats = {
  defaultFormat,
  historyAssessment: defaultFormat,
  stopAssessment: defaultFormat,
};
